import React, { memo } from 'react'
import { Grid, Stack } from '@mui/material'

import DefaultText from '../text/DefaultText'

const TabDescription = ({ description, actions }) => {
  return (
    <>
      <DefaultText label={description} component='div' />
      {actions && (
        <Grid
          container
          spacing={2}
          mt={2}
          sx={{ display: 'flex', flexDirection: 'column' }}
        >
          <Grid item xs={12}>
            <Stack
              spacing={1}
              direction={{ xs: 'column', sm: 'row', justifyContent: 'end' }}
              display={{ md: 'grid' }}
              gridAutoFlow={{ md: 'column' }}
            >
              {actions}
            </Stack>
          </Grid>
        </Grid>
      )}
    </>
  )
}

export default memo(TabDescription)
